import React, {ReactElement} from "react";
import {StudyRecap} from "../../../dicom/Parser";
import {StudyMismatch} from "../../../dicom/Mismatch";
import DateFormat from "../../../dicom/DateFormat";

export default function StudyRecapBox({recap, diff}: { recap: StudyRecap; diff: StudyMismatch | null }): ReactElement {
	const pnMismatch = !!diff?.PatientName;
	const pbdMismatch = !!diff?.PatientBirthDate;
	const sexMismatch = !!diff?.PatientSex;

	const NA = <i>{"<NOT_AVAILABLE>"}</i>;

	return (
			<div className="upload-data-box">
				<div><strong>PatientName:</strong></div>
				<div className={pnMismatch ? "mismatch" : undefined}>{recap.PatientName ?? NA}</div>

				<div><strong>PatientBirthDate:</strong></div>
				<div className={pbdMismatch ? "mismatch" : undefined}>{recap.PatientBirthDate ?? NA}</div>

				<div><strong>PatientSex:</strong></div>
				<div className={sexMismatch ? "mismatch" : undefined}>{recap.PatientSex ?? NA}</div>

				<div><strong>StudyDescription:</strong></div>
				<div>{recap.StudyDescription ?? NA}</div>

				<div><strong>StudyDate:</strong></div>
				<div>{recap.StudyDate ? DateFormat.formatDate(recap.StudyDate) : NA}</div>

				<div><strong>Modality:</strong></div>
				<div>{recap.Modality ?? NA}</div>

				<div><strong>Images:</strong></div>
				<div>{recap.numberOfImages}</div>
			</div>
	);
}
